
import React, { useState, useEffect } from "react";
import { getOptimizedImageUrl, handleImageError, ImageErrorState } from '@/utils/imageUtils';
import { Circle, Triangle, Hexagon } from 'lucide-react';

interface ProfileHeaderProps {
  profile: any;
}

const ProfileHeader: React.FC<ProfileHeaderProps> = ({ profile }) => {
  const [imageError, setImageError] = useState<ImageErrorState>({ retryCount: 0, hasError: false });
  const [imageKey, setImageKey] = useState(Date.now());
  
  useEffect(() => {
    if (profile?.updated_at || profile?.banner_image_url) {
      setImageError({ retryCount: 0, hasError: false });
      setImageKey(Date.now());
    }
  }, [profile?.updated_at, profile?.banner_image_url]);

  const bannerUrl = getOptimizedImageUrl(profile?.banner_image_url);

  return (
    <div className="absolute inset-0 h-screen">
      <div className="absolute inset-0 bg-[#1A1F2C]" />
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-accent/5 opacity-50" />
      
      {/* Add subtle background shapes */}
      <div className="absolute top-0 left-0 opacity-10">
        <Circle className="text-primary/20 w-32 h-32" strokeWidth={1} />
      </div>
      <div className="absolute bottom-0 right-0 opacity-10">
        <Triangle className="text-accent/20 w-48 h-48" strokeWidth={1} />
      </div>
      <div className="absolute top-1/4 right-1/4 opacity-10">
        <Hexagon className="text-secondary/20 w-40 h-40" strokeWidth={1} />
      </div>
      
      {bannerUrl && !imageError.hasError && (
        <div className="absolute inset-0">
          <img
            key={imageKey}
            src={bannerUrl}
            alt="Profile banner"
            className="w-full h-full object-cover"
            style={{ objectPosition: 'center center' }}
            onError={(e) => handleImageError(e, setImageError, imageError, profile?.banner_image_url)}
          />
          <div className="absolute inset-0 bg-black/40" />
        </div>
      )}
      
      {/* Gradient overlay for better text readability */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
    </div>
  );
};

export default ProfileHeader;
